/**
 * ★ VX (decisão do dono, 20/set/2026) — o nome do sistema de gestão da clínica é
 * CONFIGURAÇÃO (`config.nomeSistemaGestao`), não marca fixa: o OdontoSDR vai para
 * clínicas que não usam Careflow. Vazio → o genérico. Só o texto de tela lê isto;
 * nomes de campo (`codigoCareflow`), ids, rotas e textos já gravados não mudam.
 */
export const NOME_GENERICO = 'sistema da clínica';

export function nomeDoSistema(config) {
  const v = config?.nomeSistemaGestao;
  if (typeof v !== 'string') return NOME_GENERICO;
  const nome = v.trim();
  return nome || NOME_GENERICO;
}
